module.exports = __webpack_public_path__ + "img/contraventions-yellow.81d041bd.svg";